export default "__VITE_ASSET__C6qBwxS6__"